import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    examActions: {
      display: "flex",
      maxWidth: "75%",
      wordBreak: "break-word"
    },
    editionInfo: {
      textAlign: "end"
    },
    editButton: {
      width: 24,
      height: 24,
      padding: 0,
      border: `1px solid ${primary.light}`,
      borderRadius: 4
    },
    editButtonIcon: {
      padding: 4,
      width: 24
    },
    actions: {
      marginLeft: 16
    }
  };
});
